import script from "./ApprovalImkpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalImkpPage.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalImkpPage.vue?vue&type=style&index=0&id=58116845&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58116845"]])

export default __exports__